import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const uploadingScheduleService = {
  // Fetches employees and their existing schedules for a period
  getSchedulePreview: async (filterPayload) => {
    return await axios.post(`${domain}/api/UploadingSchedule/preview`, filterPayload, { headers });
  },

  // Fetches the list of available Shift types for the dropdowns
  getShiftSchedules: async () => {
    const response = await axios.get(`${domain}/api/Maintenance/ShiftSchedules`, { headers });
    return response.data;
  },

  // Saves the modified schedules
  saveSchedules: async (payload) => {
    return await axios.post(`${domain}/api/UploadingSchedule/save`, payload, { headers });
  }
};